import { render, staticRenderFns } from "./ContactsWidgetIcon.vue?vue&type=template&id=119a4b05"
import script from "./ContactsWidgetIcon.vue?vue&type=script&lang=js"
export * from "./ContactsWidgetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports